// Unified analytics helpers: Firebase Analytics + Meta Pixel.
// Meta Pixel base code is loaded from public/index.html (window.fbq).

import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, isSupported, setUserProperties } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDEaygJ7w7AO1HJ2c1kwQ-dxdeqtZ9mfO4",
  authDomain: "hari-om-bol-b0fb1.firebaseapp.com",
  projectId: "hari-om-bol-b0fb1",
  storageBucket: "hari-om-bol-b0fb1.firebasestorage.app",
  messagingSenderId: "1003826633756",
  appId: "1:1003826633756:web:5683f695ec67c29f7ed3d9",
  measurementId: "G-5CK6MJN37E",
};

let analyticsInstance = null;

export const initAnalytics = async () => {
  if (analyticsInstance) return analyticsInstance;
  try {
    const supported = await isSupported();
    if (!supported) return null;
    const app = initializeApp(firebaseConfig);
    analyticsInstance = getAnalytics(app);
    return analyticsInstance;
  } catch (e) {
    // analytics is best-effort; never break the app
    return null;
  }
};

const fb = (eventName, params = {}) => {
  try {
    if (analyticsInstance) logEvent(analyticsInstance, eventName, params);
  } catch (_) {}
};

const meta = (eventName, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", eventName, params);
    }
  } catch (_) {}
};

// --- Public helpers ---
export const trackPageView = (path) => {
  fb("page_view", { page_path: path });
  meta("PageView");
};

export const trackViewEvent = (event) => {
  const payload = {
    content_name: event?.title,
    content_ids: [event?.id],
    content_type: "event_ticket",
    value: Number(event?.amount_inr || 0),
    currency: "INR",
  };
  fb("view_item", payload);
  meta("ViewContent", payload);
};

export const trackBeginCheckout = ({ event, pax = 1 }) => {
  const value = Number(event?.amount_inr || 0) * Number(pax || 1);
  const payload = {
    content_name: event?.title,
    content_ids: [event?.id],
    content_type: "event_ticket",
    num_items: pax,
    value: Number(value.toFixed(2)),
    currency: "INR",
  };
  fb("begin_checkout", payload);
  meta("InitiateCheckout", payload);
};

export const trackPurchase = (booking) => {
  const payload = {
    transaction_id: booking?.booking_id,
    content_name: booking?.event_title,
    content_ids: [booking?.event_id],
    content_type: "event_ticket",
    num_items: booking?.pax,
    value: Number(booking?.total_inr || 0),
    currency: "INR",
  };
  fb("purchase", payload);
  meta("Purchase", payload);
};

export const identifyUser = ({ email, phone } = {}) => {
  try {
    if (analyticsInstance && (email || phone)) {
      setUserProperties(analyticsInstance, { has_email: !!email, has_phone: !!phone });
    }
  } catch (_) {}
};
